import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../utils/Spinner';
// import Spinner from '../../utils/Spinner';

const ProductDisplay = ({loading}) => {
    const navigate=useNavigate()
  // Get filtered products from the Redux store
  const priceFilteredProducts = useSelector(
    (state) => state.product.productFilterDetails.priceFilteredProducts
  ) || [];
    const handleNavigate = (productType,productName) => {

    navigate(`/products/${productType}/${productName}`);
  };
  if(loading){
    return(
      <>
      <Spinner/> 
      </>
    )
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
    {priceFilteredProducts?.length > 0 ? (
  priceFilteredProducts?.map((product) => (
    <div
      onClick={() => handleNavigate(product?.productType, product?.slugName)}
      key={product._id}
      className="p-4 border rounded-lg shadow hover:shadow-lg mb-5 cursor-pointer"
      style={{ height: '400px' }}
    >
      <img
        src={product.images?.[0]} // Ensure images exist
        alt={product.productName}
        className="w-full h-60 object-cover rounded-lg mb-2"
      />
      <div className="text-left py-4">
        <h3 className="font-semibold text-lg text-gray-800">{product.productName}</h3>
        <p className="text-gray-600">Price: ${product.price}</p>
        <p className="text-gray-500 text-sm">Type: {product.productType}</p>
      </div>
    </div>
  ))
) : (
  <p className="text-gray-600">No products found.</p>
)}

    </div>
  );
};

export default ProductDisplay;